import { IonContent, IonHeader, IonPage, IonRouterLink } from '@ionic/react';
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { PageLinks } from '../common/Constants';

import { Helmet } from 'react-helmet';

const HowVenetzWorks: React.FC = () => {

    return (
        <>
            <Helmet>‍
                <title>Customized Ready to install Mosquito nets with frames | Help Center</title>
                <meta name='title' content='Customized Ready to install Mosquito nets with frames' />
                <meta property='og:url' content='https://www.venetz.in/help-center' />
                <meta property='og:type' content='website' />
                <meta property='og:title' content='VENETZ | Help Center' />
                <meta property='og:description' content='VENETZ | Help Center' />
                <meta property='og:site_name' content='VENETZ' />
            </Helmet>
            <IonPage>
                {/* <Menu /> */}
                <IonHeader>
                    <Header />
                </IonHeader>
                <IonContent fullscreen id="main-content">
                    <section className="page-banner">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span className="round-shape"></span>
                                    <h2 className="banner-title">Check Me Before Ordering</h2>
                                    <div className="bread-crumb"><IonRouterLink routerLink={PageLinks.HOME} className='bread-crumb-text'>Home</IonRouterLink> / Help Center</div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="history-section help_center">
                        {/* <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2 className="sec-title">How Venetz Works?</h2>
                                    <div className="testimonials-content">
                                        <p className='about_content'>
                                            <div className='helpcenter_tab'>
                                                <iframe src="https://www.youtube.com/embed/sJUpXic5_rA?si=I3rMKfRfbfz685fM" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="container-fluid">
                            <div className="p-4">
                                <div className="row g-5 justify-content-center">
                                    {/* Video 1 */}
                                    <div className="col-xl-5 col-md-5 text-center my-3">
                                        <h3 className="text-success">How To Measure?</h3>
                                        <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                                <iframe
                                                    src="https://www.youtube.com/embed/XqcM8nwCm7o?controls=1"
                                                    title="How To Measure?"
                                                    className="rounded"
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        border: "none",
                                                    }}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Video 2 */}
                                    <div className="col-xl-5 col-md-5 text-center my-3">
                                        <h3 className="text-success">How Venetz Works?</h3>
                                        <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                                <iframe
                                                    src="https://www.youtube.com/embed/sJUpXic5_rA?si=I3rMKfRfbfz685fM"
                                                    title="How Venetz Works?"
                                                    className="rounded"
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        border: "none",
                                                    }}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Video 3 */}
                                    <div className="col-xl-5 col-md-5 text-center my-3">
                                        <h3 className="text-success">How To Order?</h3>
                                        <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                                <iframe
                                                    src="https://www.youtube.com/embed/sYDXSzN-Tso?si=OXyJjl6AI5dDLI-z"
                                                    title="How To Order?"
                                                    className="rounded"
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        border: "none",
                                                    }}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Video 4 */}
                                    <div className="col-xl-5 col-md-5 text-center my-3">
                                        <h3 className="text-success">How To Install?</h3>
                                        <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                            <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                                <iframe
                                                    src="https://www.youtube.com/embed/exzGW5_8Z38?si=UUplWy5stJENOEhU"
                                                    title="How To Install?"
                                                    className="rounded"
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        border: "none",
                                                    }}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </IonContent>
            </IonPage>
        </>
    );
};
export default HowVenetzWorks;
